webpackJsonp([126727566583207],{

/***/ 209:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(26);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _standardWrapper = __webpack_require__(27);
	
	var _standardWrapper2 = _interopRequireDefault(_standardWrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Datenschutz = function Datenschutz() {
	    return _react2.default.createElement(
	        _standardWrapper2.default,
	        null,
	        _react2.default.createElement(_reactHelmet2.default, {
	            title: 'Datenschutzerkl\xE4rung \u2013 Birkenstab',
	            meta: [{ name: 'keywords', content: 'datenschutz, datenschutzerklärung, privacy policy' }],
	            htmlAttributes: { "lang": "de" }
	        }),
	        _react2.default.createElement(
	            'h2',
	            null,
	            'Datenschutzerkl\xE4rung'
	        ),
	        _react2.default.createElement('h3', { id: 'dsg-general-intro' }),
	        _react2.default.createElement(
	            'p',
	            null,
	            'Diese Datenschutzerkl\xE4rung kl\xE4rt Sie \xFCber die Art, den Umfang und Zweck der Verarbeitung von personenbezogenen Daten (nachfolgend kurz \u201EDaten\u201C) innerhalb unseres Onlineangebotes und der mit ihm verbundenen Webseiten, Funktionen und Inhalte sowie externen Onlinepr\xE4senzen, wie z.B. unser Social Media Profile auf (nachfolgend gemeinsam bezeichnet als \u201EOnlineangebot\u201C). Im Hinblick auf die verwendeten Begrifflichkeiten, wie z.B. \u201EVerarbeitung\u201C oder \u201EVerantwortlicher\u201C verweisen wir auf die Definitionen im Art. 4 der Datenschutzgrundverordnung (DSGVO).',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null)
	        ),
	        _react2.default.createElement(
	            'h3',
	            { id: 'dsg-general-controller' },
	            'Verantwortlicher'
	        ),
	        _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	                'span',
	                { className: 'tsmcontroller' },
	                'Moritz Beck',
	                _react2.default.createElement('br', null),
	                '(Adresse auf E-Mail-Anfrage)',
	                _react2.default.createElement('br', null),
	                'Deutschland',
	                _react2.default.createElement('br', null),
	                _react2.default.createElement('br', null),
	                'E-Mail: ',
	                _react2.default.createElement(
	                    'a',
	                    { href: 'mailto:datenschutz@birkenstab.de' },
	                    'datenschutz@birkenstab.de'
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'h3',
	            { id: 'dsg-general-datatype' },
	            'Arten der verarbeiteten Daten:'
	        ),
	        _react2.default.createElement(
	            'p',
	            null,
	            '- Bestandsdaten (z.B., Namen, Adressen).',
	            _react2.default.createElement('br', null),
	            '- Kontaktdaten (z.B., E-Mail, Telefonnummern).',
	            _react2.default.createElement('br', null),
	            '- Inhaltsdaten (z.B., Texteingaben, Fotografien, Videos).',
	            _react2.default.createElement('br', null),
	            '- Nutzungsdaten (z.B., besuchte Webseiten, Interesse an Inhalten, Zugriffszeiten).',
	            _react2.default.createElement('br', null),
	            '- Meta-/Kommunikationsdaten (z.B., Ger\xE4te-Informationen, IP-Adressen).',
	            _react2.default.createElement('br', null)
	        ),
	        _react2.default.createElement(
	            'h3',
	            { id: 'dsg-general-datasubjects' },
	            'Kategorien betroffener Personen'
	        ),
	        _react2.default.createElement(
	            'p',
	            null,
	            'Besucher und Nutzer des Onlineangebotes (Nachfolgend bezeichnen wir die betroffenen Personen zusammenfassend auch als \u201ENutzer\u201C).',
	            _react2.default.createElement('br', null)
	        ),
	        _react2.default.createElement(
	            'h3',
	            { id: 'dsg-general-purpose' },
	            'Zweck der Verarbeitung'
	        ),
	        _react2.default.createElement(
	            'p',
	            null,
	            '- Zurverf\xFCgungstellung des Onlineangebotes, seiner Funktionen und  Inhalte.',
	            _react2.default.createElement('br', null),
	            '- Beantwortung von Kontaktanfragen und Kommunikation mit Nutzern.',
	            _react2.default.createElement('br', null),
	            '- Sicherheitsma\xDFnahmen.',
	            _react2.default.createElement('br', null),
	            '- Reichweitenmessung/Marketing',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('span', { className: 'tsmcom' })
	        ),
	        _react2.default.createElement(
	            'h3',
	            { id: 'dsg-general-terms' },
	            'Verwendete Begrifflichkeiten '
	        ),
	        _react2.default.createElement(
	            'p',
	            null,
	            '\u201EPersonenbezogene Daten\u201C sind alle Informationen, die sich auf eine identifizierte oder identifizierbare nat\xFCrliche Person (im Folgenden \u201Ebetroffene Person\u201C) beziehen; als identifizierbar wird eine nat\xFCrliche Person angesehen, die direkt oder indirekt, insbesondere mittels Zuordnung zu einer Kennung wie einem Namen, zu einer Kennnummer, zu Standortdaten, zu einer Online-Kennung (z.B. Cookie) oder zu einem oder mehreren besonderen Merkmalen identifiziert werden kann, die Ausdruck der physischen, physiologischen, genetischen, psychischen, wirtschaftlichen, kulturellen oder sozialen Identit\xE4t dieser nat\xFCrlichen Person sind.',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null),
	            '\u201EVerarbeitung\u201C ist jeder mit oder ohne Hilfe automatisierter Verfahren ausgef\xFChrte Vorgang oder jede solche Vorgangsreihe im Zusammenhang mit personenbezogenen Daten. Der Begriff reicht weit und umfasst praktisch jeden Umgang mit Daten.',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null),
	            '\u201EPseudonymisierung\u201C die Verarbeitung personenbezogener Daten in einer Weise, dass die personenbezogenen Daten ohne Hinzuziehung zus\xE4tzlicher Informationen nicht mehr einer spezifischen betroffenen Person zugeordnet werden k\xF6nnen, sofern diese zus\xE4tzlichen Informationen gesondert aufbewahrt werden und technischen und organisatorischen Ma\xDFnahmen unterliegen, die gew\xE4hrleisten, dass die personenbezogenen Daten nicht einer identifizierten oder identifizierbaren nat\xFCrlichen Person zugewiesen werden.',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null),
	            '\u201EProfiling\u201C jede Art der automatisierten Verarbeitung personenbezogener Daten, die darin besteht, dass diese personenbezogenen Daten verwendet werden, um bestimmte pers\xF6nliche Aspekte, die sich auf eine nat\xFCrliche Person beziehen, zu bewerten, insbesondere um Aspekte bez\xFCglich Arbeitsleistung, wirtschaftliche Lage, Gesundheit, pers\xF6nliche Vorlieben, Interessen, Zuverl\xE4ssigkeit, Verhalten, Aufenthaltsort oder Ortswechsel dieser nat\xFCrlichen Person zu analysieren oder vorherzusagen.',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null),
	            'Als \u201EVerantwortlicher\u201C wird die nat\xFCrliche oder juristische Person, Beh\xF6rde, Einrichtung oder andere Stelle, die allein oder gemeinsam mit anderen \xFCber die Zwecke und Mittel der Verarbeitung von personenbezogenen Daten entscheidet, bezeichnet.',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null),
	            '\u201EAuftragsverarbeiter\u201C eine nat\xFCrliche oder juristische Person, Beh\xF6rde, Einrichtung oder andere Stelle, die personenbezogene Daten im Auftrag des Verantwortlichen verarbeitet.',
	            _react2.default.createElement('br', null)
	        ),
	        _react2.default.createElement(
	            'h3',
	            { id: 'dsg-general-legalbasis' },
	            'Ma\xDFgebliche Rechtsgrundlagen'
	        ),
	        _react2.default.createElement(
	            'p',
	            null,
	            'Nach Ma\xDFgabe des Art. 13 DSGVO teilen wir Ihnen die Rechtsgrundlagen unserer Datenverarbeitungen mit. Sofern die Rechtsgrundlage in der Datenschutzerkl\xE4rung nicht genannt wird, gilt Folgendes: Die Rechtsgrundlage f\xFCr die Einholung von Einwilligungen ist Art. 6 Abs. 1 lit. a und Art. 7 DSGVO, die Rechtsgrundlage f\xFCr die Verarbeitung zur Erf\xFCllung unserer Leistungen und Durchf\xFChrung vertraglicher Ma\xDFnahmen sowie Beantwortung von Anfragen ist Art. 6 Abs. 1 lit. b DSGVO, die Rechtsgrundlage f\xFCr die Verarbeitung zur Erf\xFCllung unserer rechtlichen Verpflichtungen ist Art. 6 Abs. 1 lit. c DSGVO, und die Rechtsgrundlage f\xFCr die Verarbeitung zur Wahrung unserer berechtigten Interessen ist Art. 6 Abs. 1 lit. f DSGVO. F\xFCr den Fall, dass lebenswichtige Interessen der betroffenen Person oder einer anderen nat\xFCrlichen Person eine Verarbeitung personenbezogener Daten erforderlich machen, dient Art. 6 Abs. 1 lit. d DSGVO als Rechtsgrundlage.'
	        ),
	        _react2.default.createElement(
	            'h3',
	            { id: 'dsg-general-securitymeasures' },
	            'Sicherheitsma\xDFnahmen'
	        ),
	        _react2.default.createElement(
	            'p',
	            null,
	            'Wir treffen nach Ma\xDFgabe des Art. 32 DSGVO unter Ber\xFCcksichtigung des Stands der Technik, der Implementierungskosten und der Art, des Umfangs, der Umst\xE4nde und der Zwecke der Verarbeitung sowie der unterschiedlichen Eintrittswahrscheinlichkeit und Schwere des Risikos f\xFCr die Rechte und Freiheiten nat\xFCrlicher Personen, geeignete technische und organisatorische Ma\xDFnahmen, um ein dem Risiko angemessenes Schutzniveau zu gew\xE4hrleisten.',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null),
	            'Zu den Ma\xDFnahmen geh\xF6ren insbesondere die Sicherung der Vertraulichkeit, Integrit\xE4t und Verf\xFCgbarkeit von Daten durch Kontrolle des physischen Zugangs zu den Daten, als auch des sie betreffenden Zugriffs, der Eingabe, Weitergabe, der Sicherung der Verf\xFCgbarkeit und ihrer Trennung. Des Weiteren haben wir Verfahren eingerichtet, die eine Wahrnehmung von Betroffenenrechten, L\xF6schung von Daten und Reaktion auf Gef\xE4hrdung der Daten gew\xE4hrleisten. Ferner ber\xFCcksichtigen wir den Schutz personenbezogener Daten bereits bei der Entwicklung, bzw. Auswahl von Hardware, Software sowie Verfahren, entsprechend dem Prinzip des Datenschutzes durch Technikgestaltung und durch datenschutzfreundliche Voreinstellungen (Art. 25 DSGVO).',
	            _react2.default.createElement('br', null)
	        ),
	        _react2.default.createElement(
	            'h3',
	            { id: 'dsg-general-coprocessing' },
	            'Zusammenarbeit mit Auftragsverarbeitern und Dritten'
	        ),
	        _react2.default.createElement(
	            'p',
	            null,
	            'Sofern wir im Rahmen unserer Verarbeitung Daten gegen\xFCber anderen Personen und Unternehmen (Auftragsverarbeitern oder Dritten) offenbaren, sie an diese \xFCbermitteln oder ihnen sonst Zugriff auf die Daten gew\xE4hren, erfolgt dies nur auf Grundlage einer gesetzlichen Erlaubnis (z.B. wenn eine \xDCbermittlung der Daten an Dritte, wie an Zahlungsdienstleister, gem. Art. 6 Abs. 1 lit. b DSGVO zur Vertragserf\xFCllung erforderlich ist), Sie eingewilligt haben, eine rechtliche Verpflichtung dies vorsieht oder auf Grundlage unserer berechtigten Interessen (z.B. beim Einsatz von Beauftragten, Webhostern, etc.). ',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null),
	            'Sofern wir Dritte mit der Verarbeitung von Daten auf Grundlage eines sog. \u201EAuftragsverarbeitungsvertrages\u201C beauftragen, geschieht dies auf Grundlage des Art. 28 DSGVO.'
	        ),
	        _react2.default.createElement(
	            'h3',
	            { id: 'dsg-general-thirdparty' },
	            '\xDCbermittlungen in Drittl\xE4nder'
	        ),
	        _react2.default.createElement(
	            'p',
	            null,
	            'Sofern wir Daten in einem Drittland (d.h. au\xDFerhalb der Europ\xE4ischen Union (EU) oder des Europ\xE4ischen Wirtschaftsraums (EWR)) verarbeiten oder dies im Rahmen der Inanspruchnahme von Diensten Dritter oder Offenlegung, bzw. \xDCbermittlung von Daten an Dritte geschieht, erfolgt dies nur, wenn es zur Erf\xFCllung unserer (vor)vertraglichen Pflichten, auf Grundlage Ihrer Einwilligung, aufgrund einer rechtlichen Verpflichtung oder auf Grundlage unserer berechtigten Interessen geschieht. Vorbehaltlich gesetzlicher oder vertraglicher Erlaubnisse, verarbeiten oder lassen wir die Daten in einem Drittland nur beim Vorliegen der besonderen Voraussetzungen der Art. 44 ff. DSGVO verarbeiten. D.h. die Verarbeitung erfolgt z.B. auf Grundlage besonderer Garantien, wie der offiziell anerkannten Feststellung eines der EU entsprechenden Datenschutzniveaus (z.B. f\xFCr die USA durch das \u201EPrivacy Shield\u201C) oder Beachtung offiziell anerkannter spezieller vertraglicher Verpflichtungen (so genannte \u201EStandardvertragsklauseln\u201C).'
	        ),
	        _react2.default.createElement(
	            'h3',
	            { id: 'dsg-general-rightssubject' },
	            'Rechte der betroffenen Personen'
	        ),
	        _react2.default.createElement(
	            'p',
	            null,
	            'Sie haben das Recht, eine Best\xE4tigung dar\xFCber zu verlangen, ob betreffende Daten verarbeitet werden und auf Auskunft \xFCber diese Daten sowie auf weitere Informationen und Kopie der Daten entsprechend Art. 15 DSGVO.',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null),
	            'Sie haben entsprechend. Art. 16 DSGVO das Recht, die Vervollst\xE4ndigung der Sie betreffenden Daten oder die Berichtigung der Sie betreffenden unrichtigen Daten zu verlangen.',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null),
	            'Sie haben nach Ma\xDFgabe des Art. 17 DSGVO das Recht zu verlangen, dass betreffende Daten unverz\xFCglich gel\xF6scht werden, bzw. alternativ nach Ma\xDFgabe des Art. 18 DSGVO eine Einschr\xE4nkung der Verarbeitung der Daten zu verlangen.',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null),
	            'Sie haben das Recht zu verlangen, dass die Sie betreffenden Daten, die Sie uns bereitgestellt haben nach Ma\xDFgabe des Art. 20 DSGVO zu erhalten und deren \xDCbermittlung an andere Verantwortliche zu fordern. ',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null),
	            'Sie haben ferner gem. Art. 77 DSGVO das Recht, eine Beschwerde bei der zust\xE4ndigen Aufsichtsbeh\xF6rde einzureichen.'
	        ),
	        _react2.default.createElement(
	            'h3',
	            { id: 'dsg-general-revokeconsent' },
	            'Widerrufsrecht'
	        ),
	        _react2.default.createElement(
	            'p',
	            null,
	            'Sie haben das Recht, erteilte Einwilligungen gem. Art. 7 Abs. 3 DSGVO mit Wirkung f\xFCr die Zukunft zu widerrufen'
	        ),
	        _react2.default.createElement(
	            'h3',
	            { id: 'dsg-general-object' },
	            'Widerspruchsrecht'
	        ),
	        _react2.default.createElement(
	            'p',
	            null,
	            'Sie k\xF6nnen der k\xFCnftigen Verarbeitung der Sie betreffenden Daten nach Ma\xDFgabe des Art. 21 DSGVO jederzeit widersprechen. Der Widerspruch kann insbesondere gegen die Verarbeitung f\xFCr Zwecke der Direktwerbung erfolgen.'
	        ),
	        _react2.default.createElement(
	            'h3',
	            { id: 'dsg-general-cookies' },
	            'Cookies und Widerspruchsrecht bei Direktwerbung'
	        ),
	        _react2.default.createElement(
	            'p',
	            null,
	            'Als \u201ECookies\u201C werden kleine Dateien bezeichnet, die auf Rechnern der Nutzer gespeichert werden. Innerhalb der Cookies k\xF6nnen unterschiedliche Angaben gespeichert werden. Ein Cookie dient prim\xE4r dazu, die Angaben zu einem Nutzer (bzw. dem Ger\xE4t auf dem das Cookie gespeichert ist) w\xE4hrend oder auch nach seinem Besuch innerhalb eines Onlineangebotes zu speichern. Als tempor\xE4re Cookies, bzw. \u201ESession-Cookies\u201C oder \u201Etransiente Cookies\u201C, werden Cookies bezeichnet, die gel\xF6scht werden, nachdem ein Nutzer ein Onlineangebot verl\xE4sst und seinen Browser schlie\xDFt. In einem solchen Cookie kann z.B. der Inhalt eines Warenkorbs in einem Onlineshop oder ein Login-Status gespeichert werden. Als \u201Epermanent\u201C oder \u201Epersistent\u201C werden Cookies bezeichnet, die auch nach dem Schlie\xDFen des Browsers gespeichert bleiben. So kann z.B. der Login-Status gespeichert werden, wenn die Nutzer diese nach mehreren Tagen aufsuchen. Ebenso k\xF6nnen in einem solchen Cookie die Interessen der Nutzer gespeichert werden, die f\xFCr Reichweitenmessung oder Marketingzwecke verwendet werden. Als \u201EThird-Party-Cookie\u201C werden Cookies bezeichnet, die von anderen Anbietern als dem Verantwortlichen, der das Onlineangebot betreibt, angeboten werden (andernfalls, wenn es nur dessen Cookies sind spricht man von \u201EFirst-Party Cookies\u201C).',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null),
	            'Wir k\xF6nnen tempor\xE4re und permanente Cookies einsetzen und kl\xE4ren hier\xFCber im Rahmen unserer Datenschutzerkl\xE4rung auf.',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null),
	            'Falls die Nutzer nicht m\xF6chten, dass Cookies auf ihrem Rechner gespeichert werden, werden sie gebeten die entsprechende Option in den Systemeinstellungen ihres Browsers zu deaktivieren. Gespeicherte Cookies k\xF6nnen in den Systemeinstellungen des Browsers gel\xF6scht werden. Der Ausschluss von Cookies kann zu Funktionseinschr\xE4nkungen dieses Onlineangebotes f\xFChren.',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null),
	            'Ein genereller Widerspruch gegen den Einsatz der zu Zwecken des Onlinemarketing eingesetzten Cookies kann bei einer Vielzahl der Dienste, vor allem im Fall des Trackings, \xFCber die US-amerikanische Seite ',
	            _react2.default.createElement(
	                'a',
	                { href: 'http://www.aboutads.info/choices/' },
	                'http://www.aboutads.info/choices/'
	            ),
	            ' oder die EU-Seite ',
	            _react2.default.createElement(
	                'a',
	                { href: 'http://www.youronlinechoices.com/' },
	                'http://www.youronlinechoices.com/'
	            ),
	            ' erkl\xE4rt werden. Des Weiteren kann die Speicherung von Cookies mittels deren Abschaltung in den Einstellungen des Browsers erreicht werden. Bitte beachten Sie, dass dann gegebenenfalls nicht alle Funktionen dieses Onlineangebotes genutzt werden k\xF6nnen.'
	        ),
	        _react2.default.createElement(
	            'h3',
	            { id: 'dsg-general-erasure' },
	            'L\xF6schung von Daten'
	        ),
	        _react2.default.createElement(
	            'p',
	            null,
	            'Die von uns verarbeiteten Daten werden nach Ma\xDFgabe der Art. 17 und 18 DSGVO gel\xF6scht oder in ihrer Verarbeitung eingeschr\xE4nkt. Sofern nicht im Rahmen dieser Datenschutzerkl\xE4rung ausdr\xFCcklich angegeben, werden die bei uns gespeicherten Daten gel\xF6scht, sobald sie f\xFCr ihre Zweckbestimmung nicht mehr erforderlich sind und der L\xF6schung keine gesetzlichen Aufbewahrungspflichten entgegenstehen. Sofern die Daten nicht gel\xF6scht werden, weil sie f\xFCr andere und gesetzlich zul\xE4ssige Zwecke erforderlich sind, wird deren Verarbeitung eingeschr\xE4nkt. D.h. die Daten werden gesperrt und nicht f\xFCr andere Zwecke verarbeitet. Das gilt z.B. f\xFCr Daten, die aus handels- oder steuerrechtlichen Gr\xFCnden aufbewahrt werden m\xFCssen.',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null),
	            'Nach gesetzlichen Vorgaben in Deutschland, erfolgt die Aufbewahrung insbesondere f\xFCr 10 Jahre gem\xE4\xDF \xA7\xA7 147 Abs. 1 AO, 257 Abs. 1 Nr. 1 und 4, Abs. 4 HGB (B\xFCcher, Aufzeichnungen, Lageberichte, Buchungsbelege, Handelsb\xFCcher, f\xFCr Besteuerung relevanter Unterlagen, etc.) und 6 Jahre gem\xE4\xDF \xA7 257 Abs. 1 Nr. 2 und 3, Abs. 4 HGB (Handelsbriefe). ',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null),
	            'Nach gesetzlichen Vorgaben in \xD6sterreich erfolgt die Aufbewahrung insbesondere f\xFCr 7 J gem\xE4\xDF \xA7 132 Abs. 1 BAO (Buchhaltungsunterlagen, Belege/Rechnungen, Konten, Belege, Gesch\xE4ftspapiere, Aufstellung der Einnahmen und Ausgaben, etc.), f\xFCr 22 Jahre im Zusammenhang mit Grundst\xFCcken und f\xFCr 10 Jahre bei Unterlagen im Zusammenhang mit elektronisch erbrachten Leistungen, Telekommunikations-, Rundfunk- und Fernsehleistungen, die an Nichtunternehmer in EU-Mitgliedstaaten erbracht werden und f\xFCr die der Mini-One-Stop-Shop (MOSS) in Anspruch genommen wird.'
	        ),
	        _react2.default.createElement('p', null),
	        _react2.default.createElement(
	            'h3',
	            { id: 'dsg-affiliate-amazon' },
	            'Amazon-Partnerprogramm'
	        ),
	        _react2.default.createElement('p', null),
	        _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	                'span',
	                { className: 'ts-muster-content' },
	                'Wir sind auf Grundlage unserer berechtigten Interessen (d.h. Interesse am wirtschaftlichem Betrieb unseres Onlineangebotes im Sinne des Art. 6 Abs. 1 lit. f. DSGVO) Teilnehmer des Partnerprogramms von Amazon EU, das zur Bereitstellung eines Mediums f\xFCr Websites konzipiert wurde, mittels dessen durch die Platzierung von Werbeanzeigen und Links zu Amazon.de Werbekostenerstattung verdient werden kann (sog. Affiliate-System). D.h. als Amazon-Partner verdienen wir an qualifizierten K\xE4ufen.',
	                _react2.default.createElement('br', null),
	                _react2.default.createElement('br', null),
	                'Amazon setzt Cookies ein, um die Herkunft der Bestellungen nachvollziehen zu k\xF6nnen. Unter anderem kann Amazon erkennen, dass Sie den Partnerlink auf dieser Website geklickt und anschlie\xDFend ein Produkt bei Amazon erworben haben.',
	                _react2.default.createElement('br', null),
	                _react2.default.createElement('br', null),
	                'Weitere Informationen zur Datennutzung durch Amazon und Widerspruchsm\xF6glichkeiten erhalten Sie in der Datenschutzerkl\xE4rung des Unternehmens: ',
	                _react2.default.createElement(
	                    'a',
	                    { target: '_blank', href: 'https://www.amazon.de/gp/help/customer/display.html?nodeId=201909010' },
	                    'https://www.amazon.de/gp/help/customer/display.html?nodeId=201909010'
	                ),
	                '.',
	                _react2.default.createElement('br', null),
	                _react2.default.createElement('br', null),
	                'Hinweis: Amazon und das Amazon-Logo sind Warenzeichen von Amazon.com, Inc. oder eines seiner verbundenen Unternehmen.'
	            )
	        ),
	        _react2.default.createElement('p', null),
	        _react2.default.createElement(
	            'h3',
	            { id: 'dsg-registration' },
	            'Registrierfunktion'
	        ),
	        _react2.default.createElement('p', null),
	        _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	                'span',
	                { className: 'ts-muster-content' },
	                'Nutzer k\xF6nnen ein Nutzerkonto anlegen. Im Rahmen der Registrierung werden die erforderlichen Pflichtangaben den Nutzern mitgeteilt und auf Grundlage des Art. 6 Abs. 1 lit. b DSGVO zu Zwecken der Bereitstellung des Nutzerkontos verarbeitet. Zu den verarbeiteten Daten geh\xF6ren insbesondere die Login-Informationen (Name, Passwort sowie eine E-Mailadresse). Die im Rahmen der Registrierung eingegebenen Daten werden f\xFCr die Zwecke der Nutzung des Nutzerkontos und dessen Zwecks verwendet. ',
	                _react2.default.createElement('br', null),
	                _react2.default.createElement('br', null),
	                'Die Nutzer k\xF6nnen \xFCber Informationen, die f\xFCr deren Nutzerkonto relevant sind, wie z.B. technische \xC4nderungen, per E-Mail informiert werden. Wenn Nutzer ihr Nutzerkonto gek\xFCndigt haben, werden deren Daten im Hinblick auf das Nutzerkonto, vorbehaltlich einer gesetzlichen Aufbewahrungspflicht, gel\xF6scht. Es obliegt den Nutzern, ihre Daten bei erfolgter K\xFCndigung vor dem Vertragsende zu sichern. Wir sind berechtigt, s\xE4mtliche w\xE4hrend der Vertragsdauer gespeicherten Daten des Nutzers unwiederbringlich zu l\xF6schen.',
	                _react2.default.createElement('br', null),
	                _react2.default.createElement('br', null),
	                'Im Rahmen der Inanspruchnahme unserer Registrierungs- und Anmeldefunktionen sowie der Nutzung des Nutzerkontos, speichern wir die IP-Adresse und den Zeitpunkt der jeweiligen Nutzerhandlung. Die Speicherung erfolgt auf Grundlage unserer berechtigten Interessen, als auch der Nutzer an Schutz vor Missbrauch und sonstiger unbefugter Nutzung. Eine Weitergabe dieser Daten an Dritte erfolgt grunds\xE4tzlich nicht, au\xDFer sie ist zur Verfolgung unserer Anspr\xFCche erforderlich oder es besteht hierzu besteht eine gesetzliche Verpflichtung gem. Art. 6 Abs. 1 lit. c. DSGVO. Die IP-Adressen werden sp\xE4testens nach 7 Tagen anonymisiert oder gel\xF6scht.',
	                _react2.default.createElement('br', null)
	            )
	        ),
	        _react2.default.createElement('p', null),
	        _react2.default.createElement(
	            'h3',
	            { id: 'dsg-disqus' },
	            'DISQUS-Kommentarfunktion'
	        ),
	        _react2.default.createElement('p', null),
	        _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	                'span',
	                { className: 'ts-muster-content' },
	                'Wir setzen auf Grundlage unserer berechtigten Interessen an einer effizienten, sicheren und nutzerfreundlichen Kommentarverwaltung gem. Art. 6 Abs. 1 lit. f. DSGVO den Kommentardienst DISQUS, angeboten von der DISQUS, Inc., 301 Howard St, Floor 3 San Francisco, California- 94105, USA, ein. DISQUS ist unter dem Privacy-Shield-Abkommen zertifiziert und bietet hierdurch eine Garantie, das europ\xE4ische Datenschutzrecht einzuhalten: ',
	                _react2.default.createElement(
	                    'a',
	                    { target: '_blank', href: 'https://www.privacyshield.gov/participant?id=a2zt0000000TRkEAAW&status=Active' },
	                    'https://www.privacyshield.gov/participant?id=a2zt0000000TRkEAAW&status=Active'
	                ),
	                '.',
	                _react2.default.createElement('br', null),
	                _react2.default.createElement('br', null),
	                'Zur Nutzung der DISQUS Kommentarfunktion k\xF6nnen Nutzer sich \xFCber ein eigenes DISQUS-Nutzer-Konto oder einen bestehende Social-Media-Konten (z.B. OpenID, Facebook, Twitter oder Google) anmelden. Hierbei werden die Anmeldedaten der Nutzer durch DISQUS von den Plattformen bezogen. Es ist ebenfalls m\xF6glich, die DISQUS-Kommentarfunktion als Gast, ohne Erstellung oder Verwendung Nutzerkontos bei DISQUS oder einem der angegebenen Social-Media-Anbieter, zu nutzen.',
	                _react2.default.createElement('br', null),
	                _react2.default.createElement('br', null),
	                'Wir betten lediglich DISQUS mit seinen Funktionen in unsere Website ein, wobei wir auf die Kommentare der Nutzer Einfluss nehmen k\xF6nnen. Die Nutzer treten jedoch in eine unmittelbare Vertragsbeziehung mit DISQUS, in deren Rahmen DISQUS die Kommentare der Nutzer verarbeitet und ein Ansprechpartner f\xFCr etwaige L\xF6schung der Daten der Nutzer ist. Wir verweisen hierbei auf die Datenschutzerkl\xE4rung von DISQUS: ',
	                _react2.default.createElement(
	                    'a',
	                    { target: '_blank', href: 'https://help.disqus.com/terms-and-policies/disqus-privacy-policy' },
	                    'https://help.disqus.com/terms-and-policies/disqus-privacy-policy'
	                ),
	                ' und weisen die Nutzer ebenfalls darauf hin, dass sie davon ausgehen k\xF6nnen, dass DISQUS neben dem Kommentarinhalt auch deren IP-Adresse und den Zeitpunkt des Kommentars speichert sowie Cookies auf den Rechnern der Nutzer speichert und zur Darstellung von Werbung nutzen kann. Nutzer k\xF6nnen jedoch der Verarbeitung ihrer Daten zwecks Darstellung von Anzeigen widersprechen: ',
	                _react2.default.createElement(
	                    'a',
	                    { target: '_blank', href: 'https://disqus.com/data-sharing-settings/' },
	                    'https://disqus.com/data-sharing-settings'
	                ),
	                '. ',
	                _react2.default.createElement('br', null)
	            )
	        ),
	        _react2.default.createElement('p', null),
	        _react2.default.createElement(
	            'h3',
	            { id: 'dsg-comments' },
	            'Kommentare und Beitr\xE4ge'
	        ),
	        _react2.default.createElement('p', null),
	        _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	                'span',
	                { className: 'ts-muster-content' },
	                'Wenn Nutzer Kommentare oder sonstige Beitr\xE4ge hinterlassen, k\xF6nnen ihre IP-Adressen auf Grundlage unserer berechtigten Interessen im Sinne des Art. 6 Abs. 1 lit. f. DSGVO f\xFCr 7 Tage gespeichert werden. Das erfolgt zu unserer Sicherheit, falls jemand in Kommentaren und Beitr\xE4gen widerrechtliche Inhalte hinterl\xE4sst (Beleidigungen, verbotene politische Propaganda, etc.). In diesem Fall k\xF6nnen wir selbst f\xFCr den Kommentar oder Beitrag belangt werden und sind daher an der Identit\xE4t des Verfassers interessiert.',
	                _react2.default.createElement('br', null),
	                _react2.default.createElement('br', null),
	                'Des Weiteren behalten wir uns vor, auf Grundlage unserer berechtigten Interessen gem. Art. 6 Abs. 1 lit. f. DSGVO, die Angaben der Nutzer zwecks Spamerkennung zu verarbeiten.',
	                _react2.default.createElement('br', null),
	                _react2.default.createElement('br', null),
	                'Auf derselben Rechtsgrundlage behalten wir uns vor, im Fall von Umfragen die IP-Adressen der Nutzer f\xFCr deren Dauer zu speichern und Cookies zu verwenden, um Mehrfachabstimmungen zu vermeiden.',
	                _react2.default.createElement('br', null),
	                _react2.default.createElement('br', null),
	                'Die im Rahmen der Kommentare und Beitr\xE4ge angegebenen Daten, werden von uns bis zum Widerspruch der Nutzer dauerhaft gespeichert.'
	            )
	        ),
	        _react2.default.createElement('p', null),
	        _react2.default.createElement(
	            'h3',
	            { id: 'dsg-gravatar' },
	            'Abruf von Profilbildern bei Gravatar'
	        ),
	        _react2.default.createElement('p', null),
	        _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	                'span',
	                { className: 'ts-muster-content' },
	                'Wir setzen innerhalb unseres Onlineangebotes und insbesondere im Blog den Dienst Gravatar der Automattic Inc., 60 29th Street #343, San Francisco, CA 94110, USA, ein.',
	                _react2.default.createElement('br', null),
	                _react2.default.createElement('br', null),
	                'Gravatar ist ein Dienst, bei dem sich Nutzer anmelden und Profilbilder und ihre E-Mailadressen hinterlegen k\xF6nnen. Wenn Nutzer mit der jeweiligen E-Mailadresse auf anderen Onlinepr\xE4senzen (vor allem in Blogs) Beitr\xE4ge oder Kommentare hinterlassen, k\xF6nnen so deren Profilbilder neben den Beitr\xE4gen oder Kommentaren dargestellt werden. Hierzu wird die von den Nutzern mitgeteilte E-Mailadresse an Gravatar zwecks Pr\xFCfung, ob zu ihr ein Profil gespeichert ist, verschl\xFCsselt \xFCbermittelt. Dies ist der einzige Zweck der \xDCbermittlung der E-Mailadresse und sie wird nicht f\xFCr andere Zwecke verwendet, sondern danach gel\xF6scht.',
	                _react2.default.createElement('br', null),
	                _react2.default.createElement('br', null),
	                'Die Nutzung von Gravatar erfolgt auf Grundlage unserer berechtigten Interessen im Sinne des Art. 6 Abs. 1 lit. f) DSGVO, da wir mit Hilfe von Gravatar den Beitrags- und Kommentarverfassern die M\xF6glichkeit bieten ihre Beitr\xE4ge mit einem Profilbild zu personalisieren.',
	                _react2.default.createElement('br', null),
	                _react2.default.createElement('br', null),
	                'Durch die Anzeige der Bilder bringt Gravatar die IP-Adresse der Nutzer in Erfahrung, da dies f\xFCr eine Kommunikation zwischen einem Browser und einem Onlineservice notwendig ist. N\xE4here Informationen zur Erhebung und Nutzung der Daten durch Gravatar finden sich in den Datenschutzhinweisen von Automattic: ',
	                _react2.default.createElement(
	                    'a',
	                    { target: '_blank', href: 'https://automattic.com/privacy/' },
	                    'https://automattic.com/privacy/'
	                ),
	                '.',
	                _react2.default.createElement('br', null),
	                _react2.default.createElement('br', null),
	                'Wenn Nutzer nicht m\xF6chten, dass ein mit Ihrer E-Mail-Adresse bei Gravatar verkn\xFCpftes Benutzerbild in den Kommentaren erscheint, sollten Sie zum Kommentieren eine E-Mail-Adresse nutzen, welche nicht bei Gravatar hinterlegt ist. Wir weisen ferner darauf hin, dass es auch m\xF6glich ist eine anonyme oder gar keine E-Mailadresse zu verwenden, falls die Nutzer nicht w\xFCnschen, dass die eigene E-Mailadresse an Gravatar \xFCbersendet wird. Nutzer k\xF6nnen die \xDCbertragung der Daten komplett verhindern, indem Sie unser Kommentarsystem nicht nutzen.'
	            )
	        ),
	        _react2.default.createElement('p', null),
	        _react2.default.createElement(
	            'h3',
	            { id: 'dsg-hostingprovider' },
	            'Hosting und E-Mail-Versand'
	        ),
	        _react2.default.createElement('p', null),
	        _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	                'span',
	                { className: 'ts-muster-content' },
	                'Die von uns in Anspruch genommenen Hosting-Leistungen dienen der Zurverf\xFCgungstellung der folgenden Leistungen: Infrastruktur- und Plattformdienstleistungen, Rechenkapazit\xE4t, Speicherplatz und Datenbankdienste, E-Mail-Versand, Sicherheitsleistungen sowie technische Wartungsleistungen, die wir zum Zwecke des Betriebs dieses Onlineangebotes einsetzen. ',
	                _react2.default.createElement('br', null),
	                _react2.default.createElement('br', null),
	                'Hierbei verarbeiten wir, bzw. unser Hostinganbieter Bestandsdaten, Kontaktdaten, Inhaltsdaten, Vertragsdaten, Nutzungsdaten, Meta- und Kommunikationsdaten von Kunden, Interessenten und Besuchern dieses Onlineangebotes auf Grundlage unserer berechtigten Interessen an einer effizienten und sicheren Zurverf\xFCgungstellung dieses Onlineangebotes gem. Art. 6 Abs. 1 lit. f DSGVO i.V.m. Art. 28 DSGVO (Abschluss Auftragsverarbeitungsvertrag).'
	            )
	        ),
	        _react2.default.createElement('p', null),
	        _react2.default.createElement(
	            'h3',
	            { id: 'dsg-logfiles' },
	            'Erhebung von Zugriffsdaten und Logfiles'
	        ),
	        _react2.default.createElement('p', null),
	        _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	                'span',
	                { className: 'ts-muster-content' },
	                'Wir, bzw. unser Hostinganbieter, erhebt auf Grundlage unserer berechtigten Interessen im Sinne des Art. 6 Abs. 1 lit. f. DSGVO Daten \xFCber jeden Zugriff auf den Server, auf dem sich dieser Dienst befindet (sogenannte Serverlogfiles). Zu den Zugriffsdaten geh\xF6ren Name der abgerufenen Webseite, Datei, Datum und Uhrzeit des Abrufs, \xFCbertragene Datenmenge, Meldung \xFCber erfolgreichen Abruf, Browsertyp nebst Version, das Betriebssystem des Nutzers, Referrer URL (die zuvor besuchte Seite), IP-Adresse und der anfragende Provider.',
	                _react2.default.createElement('br', null),
	                _react2.default.createElement('br', null),
	                'Logfile-Informationen werden aus Sicherheitsgr\xFCnden (z.B. zur Aufkl\xE4rung von Missbrauchs- oder Betrugshandlungen) f\xFCr die Dauer von maximal 7 Tagen gespeichert und danach gel\xF6scht. Daten, deren weitere Aufbewahrung zu Beweiszwecken erforderlich ist, sind bis zur endg\xFCltigen Kl\xE4rung des jeweiligen Vorfalls von der L\xF6schung ausgenommen.'
	            )
	        ),
	        _react2.default.createElement('p', null),
	        _react2.default.createElement(
	            'h3',
	            { id: 'dsg-socialmedia' },
	            'Onlinepr\xE4senzen in sozialen Medien'
	        ),
	        _react2.default.createElement('p', null),
	        _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	                'span',
	                { className: 'ts-muster-content' },
	                'Wir unterhalten Onlinepr\xE4senzen innerhalb sozialer Netzwerke und Plattformen, um mit den dort aktiven Kunden, Interessenten und Nutzern kommunizieren und sie dort \xFCber unsere Leistungen informieren zu k\xF6nnen.',
	                _react2.default.createElement('br', null),
	                _react2.default.createElement('br', null),
	                'Wir weisen darauf hin, dass dabei Daten der Nutzer au\xDFerhalb des Raumes der Europ\xE4ischen Union verarbeitet werden k\xF6nnen. Hierdurch k\xF6nnen sich f\xFCr die Nutzer Risiken ergeben, weil so z.B. die Durchsetzung der Rechte der Nutzer erschwert werden k\xF6nnte. Im Hinblick auf US-Anbieter die unter dem Privacy-Shield zertifiziert sind, weisen wir darauf hin, dass sie sich damit verpflichten, die Datenschutzstandards der EU einzuhalten.',
	                _react2.default.createElement('br', null),
	                _react2.default.createElement('br', null),
	                'Ferner werden die Daten der Nutzer im Regelfall f\xFCr Marktforschungs- und Werbezwecke verarbeitet. So k\xF6nnen z.B. aus dem Nutzungsverhalten und sich daraus ergebenden Interessen der Nutzer Nutzungsprofile erstellt werden. Die Nutzungsprofile k\xF6nnen wiederum verwendet werden, um z.B. Werbeanzeigen innerhalb und au\xDFerhalb der Plattformen zu schalten, die mutma\xDFlich den Interessen der Nutzer entsprechen. Zu diesen Zwecken werden im Regelfall Cookies auf den Rechnern der Nutzer gespeichert, in denen das Nutzungsverhalten und die Interessen der Nutzer gespeichert werden. Ferner k\xF6nnen in den Nutzungsprofilen auch Daten unabh\xE4ngig der von den Nutzern verwendeten Ger\xE4te gespeichert werden (insbesondere wenn die Nutzer Mitglieder der jeweiligen Plattformen sind und bei diesen eingeloggt sind).',
	                _react2.default.createElement('br', null),
	                _react2.default.createElement('br', null),
	                'Die Verarbeitung der personenbezogenen Daten der Nutzer erfolgt auf Grundlage unserer berechtigten Interessen an einer effektiven Information der Nutzer und Kommunikation mit den Nutzern gem. Art. 6 Abs. 1 lit. f. DSGVO. Falls die Nutzer von den jeweiligen Anbietern um eine Einwilligung in die Datenverarbeitung gebeten werden (d.h. ihr Einverst\xE4ndnis z.B. \xFCber das Anhaken eines Kontrollk\xE4stchens oder Best\xE4tigung einer Schaltfl\xE4che erkl\xE4ren) ist die Rechtsgrundlage der Verarbeitung Art. 6 Abs. 1 lit. a., Art. 7 DSGVO.',
	                _react2.default.createElement('br', null),
	                _react2.default.createElement('br', null),
	                'F\xFCr eine detaillierte Darstellung der jeweiligen Verarbeitungen und der Widerspruchsm\xF6glichkeiten (Opt-Out), verweisen wir auf die nachfolgend verlinkten Angaben der Anbieter.',
	                _react2.default.createElement('br', null),
	                _react2.default.createElement('br', null),
	                'Auch im Fall von Auskunftsanfragen und der Geltendmachung von Nutzerrechten, weisen wir darauf hin, dass diese am effektivsten bei den Anbietern geltend gemacht werden k\xF6nnen. Nur die Anbieter haben jeweils Zugriff auf die Daten der Nutzer und k\xF6nnen direkt entsprechende Ma\xDFnahmen ergreifen und Ausk\xFCnfte geben. Sollten Sie dennoch Hilfe ben\xF6tigen, dann k\xF6nnen Sie sich an uns wenden.',
	                _react2.default.createElement('br', null),
	                _react2.default.createElement('br', null),
	                '- Facebook (Facebook Ireland Ltd., 4 Grand Canal Square, Grand Canal Harbour, Dublin 2, Irland) - Datenschutzerkl\xE4rung: ',
	                _react2.default.createElement(
	                    'a',
	                    { target: '_blank', href: 'https://www.facebook.com/about/privacy/' },
	                    'https://www.facebook.com/about/privacy/'
	                ),
	                ', Opt-Out: ',
	                _react2.default.createElement(
	                    'a',
	                    { target: '_blank', href: 'https://www.facebook.com/settings?tab=ads' },
	                    'https://www.facebook.com/settings?tab=ads'
	                ),
	                ' und ',
	                _react2.default.createElement(
	                    'a',
	                    { target: '_blank', href: 'http://www.youronlinechoices.com' },
	                    'http://www.youronlinechoices.com'
	                ),
	                ', Privacy Shield: ',
	                _react2.default.createElement(
	                    'a',
	                    { target: '_blank', href: 'https://www.privacyshield.gov/participant?id=a2zt0000000GnywAAC&status=Active' },
	                    'https://www.privacyshield.gov/participant?id=a2zt0000000GnywAAC&status=Active'
	                ),
	                '.',
	                _react2.default.createElement('br', null),
	                _react2.default.createElement('br', null),
	                '- Google/ YouTube (Google LLC, 1600 Amphitheatre Parkway, Mountain View, CA 94043, USA) \u2013 Datenschutzerkl\xE4rung: \xA0',
	                _react2.default.createElement(
	                    'a',
	                    { target: '_blank', href: 'https://policies.google.com/privacy' },
	                    'https://policies.google.com/privacy'
	                ),
	                ', Opt-Out: ',
	                _react2.default.createElement(
	                    'a',
	                    { target: '_blank', href: 'https://adssettings.google.com/authenticated' },
	                    'https://adssettings.google.com/authenticated'
	                ),
	                ', Privacy Shield: ',
	                _react2.default.createElement(
	                    'a',
	                    { target: '_blank', href: 'https://www.privacyshield.gov/participant?id=a2zt000000001L5AAI&status=Active' },
	                    'https://www.privacyshield.gov/participant?id=a2zt000000001L5AAI&status=Active'
	                ),
	                '.',
	                _react2.default.createElement('br', null),
	                _react2.default.createElement('br', null),
	                '- Instagram (Instagram Inc., 1601 Willow Road, Menlo Park, CA, 94025, USA) \u2013 Datenschutzerkl\xE4rung/ Opt-Out: ',
	                _react2.default.createElement(
	                    'a',
	                    { target: '_blank', href: 'http://instagram.com/about/legal/privacy/' },
	                    'http://instagram.com/about/legal/privacy/'
	                ),
	                '.',
	                _react2.default.createElement('br', null),
	                _react2.default.createElement('br', null),
	                '- Twitter (Twitter Inc., 1355 Market Street, Suite 900, San Francisco, CA 94103, USA) - Datenschutzerkl\xE4rung: ',
	                _react2.default.createElement(
	                    'a',
	                    { target: '_blank', href: 'https://twitter.com/de/privacy' },
	                    'https://twitter.com/de/privacy'
	                ),
	                ', Opt-Out: ',
	                _react2.default.createElement(
	                    'a',
	                    { target: '_blank', href: 'https://twitter.com/personalization' },
	                    'https://twitter.com/personalization'
	                ),
	                ', Privacy Shield: ',
	                _react2.default.createElement(
	                    'a',
	                    { target: '_blank', href: 'https://www.privacyshield.gov/participant?id=a2zt0000000TORzAAO&status=Active' },
	                    'https://www.privacyshield.gov/participant?id=a2zt0000000TORzAAO&status=Active'
	                ),
	                '.',
	                _react2.default.createElement('br', null),
	                _react2.default.createElement('br', null),
	                '- Pinterest (Pinterest Inc., 635 High Street, Palo Alto, CA, 94301, USA) \u2013 Datenschutzerkl\xE4rung/ Opt-Out: ',
	                _react2.default.createElement(
	                    'a',
	                    { target: '_blank', href: 'https://about.pinterest.com/de/privacy-policy' },
	                    'https://about.pinterest.com/de/privacy-policy'
	                ),
	                '.',
	                _react2.default.createElement('br', null),
	                _react2.default.createElement('br', null),
	                '- LinkedIn (LinkedIn Ireland Unlimited Company Wilton Place, Dublin 2, Irland) - Datenschutzerkl\xE4rung ',
	                _react2.default.createElement(
	                    'a',
	                    { target: '_blank', href: 'https://www.linkedin.com/legal/privacy-policy' },
	                    'https://www.linkedin.com/legal/privacy-policy'
	                ),
	                ' , Opt-Out: ',
	                _react2.default.createElement(
	                    'a',
	                    { target: '_blank', href: 'https://www.linkedin.com/psettings/guest-controls/retargeting-opt-out' },
	                    'https://www.linkedin.com/psettings/guest-controls/retargeting-opt-out'
	                ),
	                ', Privacy Shield:\xA0',
	                _react2.default.createElement(
	                    'a',
	                    { target: '_blank', href: 'https://www.privacyshield.gov/participant?id=a2zt0000000L0UZAA0&status=Active' },
	                    'https://www.privacyshield.gov/participant?id=a2zt0000000L0UZAA0&status=Active'
	                ),
	                '.',
	                _react2.default.createElement('br', null),
	                _react2.default.createElement('br', null),
	                '- Xing (XING AG, Dammtorstra\xDFe 29-32, 20354 Hamburg, Deutschland) - Datenschutzerkl\xE4rung/ Opt-Out: ',
	                _react2.default.createElement(
	                    'a',
	                    { target: '_blank', href: 'https://privacy.xing.com/de/datenschutzerklaerung' },
	                    'https://privacy.xing.com/de/datenschutzerklaerung'
	                ),
	                '.'
	            )
	        ),
	        _react2.default.createElement('p', null),
	        _react2.default.createElement(
	            'h3',
	            { id: 'dsg-thirdparty-einleitung' },
	            'Einbindung von Diensten und Inhalten Dritter'
	        ),
	        _react2.default.createElement('p', null),
	        _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	                'span',
	                { className: 'ts-muster-content' },
	                'Wir setzen innerhalb unseres Onlineangebotes auf Grundlage unserer berechtigten Interessen (d.h. Interesse an der Analyse, Optimierung und wirtschaftlichem Betrieb unseres Onlineangebotes im Sinne des Art. 6 Abs. 1 lit. f. DSGVO) Inhalts- oder Serviceangebote von Drittanbietern ein, um deren Inhalte und Services, wie z.B. Videos oder Schriftarten einzubinden (nachfolgend einheitlich bezeichnet als \u201CInhalte\u201D). ',
	                _react2.default.createElement('br', null),
	                _react2.default.createElement('br', null),
	                'Dies setzt immer voraus, dass die Drittanbieter dieser Inhalte, die IP-Adresse der Nutzer wahrnehmen, da sie ohne die IP-Adresse die Inhalte nicht an deren Browser senden k\xF6nnten. Die IP-Adresse ist damit f\xFCr die Darstellung dieser Inhalte erforderlich. Wir bem\xFChen uns nur solche Inhalte zu verwenden, deren jeweilige Anbieter die IP-Adresse lediglich zur Auslieferung der Inhalte verwenden. Drittanbieter k\xF6nnen ferner so genannte Pixel-Tags (unsichtbare Grafiken, auch als "Web Beacons" bezeichnet) f\xFCr statistische oder Marketingzwecke verwenden. Durch die "Pixel-Tags" k\xF6nnen Informationen, wie der Besucherverkehr auf den Seiten dieser Website ausgewertet werden. Die pseudonymen Informationen k\xF6nnen ferner in Cookies auf dem Ger\xE4t der Nutzer gespeichert werden und unter anderem technische Informationen zum Browser und Betriebssystem, verweisende Webseiten, Besuchszeit sowie weitere Angaben zur Nutzung unseres Onlineangebotes enthalten, als auch mit solchen Informationen aus anderen Quellen verbunden werden.'
	            )
	        ),
	        _react2.default.createElement('p', null),
	        _react2.default.createElement(
	            'h3',
	            { id: 'dsg-thirdparty-youtube' },
	            'Youtube'
	        ),
	        _react2.default.createElement('p', null),
	        _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	                'span',
	                { className: 'ts-muster-content' },
	                'Wir binden die Videos der Plattform \u201CYouTube\u201D des Anbieters Google LLC, 1600 Amphitheatre Parkway, Mountain View, CA 94043, USA, ein. Datenschutzerkl\xE4rung: ',
	                _react2.default.createElement(
	                    'a',
	                    { target: '_blank', href: 'https://www.google.com/policies/privacy/' },
	                    'https://www.google.com/policies/privacy/'
	                ),
	                ', Opt-Out: ',
	                _react2.default.createElement(
	                    'a',
	                    { target: '_blank', href: 'https://adssettings.google.com/authenticated' },
	                    'https://adssettings.google.com/authenticated'
	                ),
	                '.'
	            )
	        ),
	        _react2.default.createElement('p', null),
	        _react2.default.createElement(
	            'h3',
	            { id: 'dsg-thirdparty-googlerecaptcha' },
	            'Google ReCaptcha'
	        ),
	        _react2.default.createElement('p', null),
	        _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	                'span',
	                { className: 'ts-muster-content' },
	                'Wir binden die Funktion zur Erkennung von Bots, z.B. bei Eingaben in Onlineformularen ("ReCaptcha") des Anbieters Google LLC, 1600 Amphitheatre Parkway, Mountain View, CA 94043, USA, ein. Datenschutzerkl\xE4rung: ',
	                _react2.default.createElement(
	                    'a',
	                    { target: '_blank', href: 'https://www.google.com/policies/privacy/' },
	                    'https://www.google.com/policies/privacy/'
	                ),
	                ', Opt-Out: ',
	                _react2.default.createElement(
	                    'a',
	                    { target: '_blank', href: 'https://adssettings.google.com/authenticated' },
	                    'https://adssettings.google.com/authenticated'
	                ),
	                '.'
	            )
	        ),
	        _react2.default.createElement('p', null),
	        _react2.default.createElement(
	            'h3',
	            { id: 'dsg-thirdparty-googlemaps' },
	            'Google Maps'
	        ),
	        _react2.default.createElement('p', null),
	        _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	                'span',
	                { className: 'ts-muster-content' },
	                'Wir binden die Landkarten des Dienstes \u201CGoogle Maps\u201D des Anbieters Google LLC, 1600 Amphitheatre Parkway, Mountain View, CA 94043, USA, ein. Zu den verarbeiteten Daten k\xF6nnen insbesondere IP-Adressen und Standortdaten der Nutzer geh\xF6ren, die jedoch nicht ohne deren Einwilligung (im Regelfall im Rahmen der Einstellungen ihrer Mobilger\xE4te vollzogen), erhoben werden. Die Daten k\xF6nnen in den USA verarbeitet werden. Datenschutzerkl\xE4rung: ',
	                _react2.default.createElement(
	                    'a',
	                    { target: '_blank', href: 'https://www.google.com/policies/privacy/' },
	                    'https://www.google.com/policies/privacy/'
	                ),
	                ', Opt-Out: ',
	                _react2.default.createElement(
	                    'a',
	                    { target: '_blank', href: 'https://adssettings.google.com/authenticated' },
	                    'https://adssettings.google.com/authenticated'
	                ),
	                '.'
	            )
	        ),
	        _react2.default.createElement(
	            'a',
	            { href: 'https://datenschutz-generator.de', className: 'dsg1-5', rel: 'nofollow', target: '_blank' },
	            'Erstellt mit Datenschutz-Generator.de von RA Dr. Thomas Schwenke'
	        )
	    );
	};
	
	exports.default = Datenschutz;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-datenschutz-js-0dfc09a7075c9a3107c4.js